import styles from "./styles.module.scss";
import { useContext } from "react";

import { ModalComponentProps } from "./types";
import { useSignModal } from "../../../contexts/sign-modal/index.context";
import { TranslationContext } from "../../../contexts/translation/index.context";
//UI
import Button from "antd/lib/button";
import Modal from "antd/lib/modal";

export default function ModalComponent(props: ModalComponentProps) {
  const { isOpen, token, closeSignModal } = useSignModal();
  const { intl, language } = useContext(TranslationContext);
  const lang = language ? "uk" : "en";

  const style =
    props.name === "isModalOpen"
      ? styles["modal-with-footer"]
      : styles["modal"];

  return (
    <Modal
      className={style}
      open={isOpen}
      okText={intl("ok")}
      onOk={closeSignModal}
      onCancel={closeSignModal}
      footer={
        <Button key="cancel" onClick={closeSignModal}>
          {intl("cancel")}
        </Button>
      }
      destroyOnClose
    >
      <iframe
        // src={`http://localhost:3003/signer?token=${token}&lang=${lang}`}
        src={`https://signa.kai-doc.com.ua/signer?token=${token}&lang=${lang}`}
        id="verify-widget"
        title="Verification Service"
        width="100%"
        height="350px"
        style={{ border: "none" }}
      />
    </Modal>
  );
}
